<template>
  <transition name="modal">
    <div class="modal-mask" @keyup.esc="$emit('close')">
      <div class="modal">
        <div class="modal__header">
          <slot name="header"></slot>
        </div>
        <div class="modal__content">
          <div class="modal__body">
            <slot name="form"></slot>
          </div>
          <div class="modal__footer">
            <div>
              <button
                accept
                class="btn btn--white modal__btn"
                @click="$emit('close')"
              >
                {{ $t("global.button.accept") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style src="./css/modalDialogFrame.css"></style>

<script>
export default {
  name: "MessageDialog"
};
</script>
